import { createAction, props } from '@ngrx/store';
import { PromptTypes } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { PromptDetailSaveEvent } from '../models/prompt-detail-form-submit-event';
import { GetPromptDetail_prompt } from '../queries/generated/GetPromptDetail';
import { SavePrompt } from '../queries/generated/SavePrompt';

export const promptDetailLoad = createAction('[Prompt Detail] Load');

export const promptDetailCancel = createAction('[Prompt Detail] Cancel');

export const promptDetailAccessDenied = createAction('[Prompt Detail] Access Denied');

export const loadPromptDetailSuccess = createAction(
   '[API] Load Prompt Success',
   props<{ data: GetPromptDetail_prompt }>()
);

export const uploadWrongFileType = createAction('[API] Upload File Failure', props<{ data: string }>());

export const loadPromptDetailFailure = createAction('[API] Load Prompt Failure', props<SingleGraphError>());

export const changePromptFile = createAction(
   '[Prompt Detail] Change Prompt File',
   props<{ promptType: PromptTypes; promptId: number | null; name: string; accountId: number | null }>()
);

export const revertPromptFileUpdateOnNavigate = createAction(
   '[Prompt Detail] Revert Prompt File Update On Navigate Away',
   props<{ prompt: PromptDetailSaveEvent; fileId: number }>()
);

export const revertPromptFileSuccess = createAction('[Prompt Detail] Revert Prompt File Success');

export const revertPromptFileFailure = createAction(
   '[Prompt Detail] Revert Prompt File Failed',
   props<SingleGraphError>()
);

export const deleteNewFileIfPromptSaveCanceled = createAction(
   '[API] Delete File Created',
   props<{ fileId: number | null }>()
);

export const deleteFileSuccess = createAction('[API] Delete File Success');

export const deleteFileFailure = createAction('[API] Delete File Failure', props<SingleGraphError>());

export const savePromptDetail = createAction('[Prompt Detail] Save', props<PromptDetailSaveEvent>());

export const savePromptDetailSuccess = createAction('[Prompt Detail] Save Success', props<{ data: SavePrompt }>());

export const savePromptDetailFailure = createAction('[Prompt Detail] Save Failed', props<SingleGraphError>());

export const deletePrompt = createAction(
   '[Prompt Detail] Delete Prompt',
   props<{ promptId: number; name: string | null }>()
);

export const deletePromptSuccess = createAction(
   '[Prompt Detail] Delete Prompt Success',
   props<{ name: string | null }>()
);

export const deletePromptFailure = createAction('[Prompt Detail] Delete Prompt Failure', props<SingleGraphError>());
